module.exports = __webpack_public_path__ + "teqbahn-assets/media/2.5304bb63.png";